import { IGetAllUsuarioUseCase } from "../../../presentation/useCases/read/get_all_usuario_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { UsuariosListaDao } from "../../models/usuariosLista";
import { IAdministracaoRepository } from "../../repositories/administracao_repository";

/**
 * GetAllUsuarioUseCase
 */

export class GetAllUsuarioUseCase extends BasePaginatedUseCase<UsuariosListaDao> implements IGetAllUsuarioUseCase {
  constructor(private readonly repository: IAdministracaoRepository) {
    super();
  }
  async execute(
    nome?: string,
    login?: string,
    email?: string,
    status?: number,
    idsGrupoAcesso?: number[],
    idsCentroCusto?: number[],

    currentPage?: number | null,
    rowsPerPage?: number | null,
  ): Promise<void> {

    const result = await this.repository.getAllUsuariosLista(
      nome,
      login,
      email,
      status,
      idsGrupoAcesso,
      idsCentroCusto,

      currentPage,
      rowsPerPage,
    );

    this._items = result.items;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;

  }
}
